import { Stack } from "@mui/material";
import MediaPlayerMarkers, { MediaPlayerClips } from "./media-player-markers-in-timeline";
import {
  GetActiveTimeline,
  GetCreatingOrEditingTimelineEvent,
  GetFilteredTimelineClips,
  GetFilteredTimelineMarkers,
  GetFocusedTimelineClip,
  GetTimelineTranscriptItems,
  TimelineType,
} from "../../../Redux/Reducers/redux-slice-timeline";
import { useSelector } from "react-redux";
import { forwardRef } from "react";
import { GetFrameRate, GetRealCurrentFrame, GetTimeInSec } from "../../../Redux/Reducers/redux-slice-react-player";
import { SingleCaption } from "../../../Pages/Scribetool/single-caption";

export const PlayerTimeline = forwardRef<HTMLDivElement, any>((props, ref) => {
  const activeTimeline = useSelector(GetActiveTimeline);
  const timelineClips = useSelector(GetFilteredTimelineClips);
  const focusedClip = useSelector(GetFocusedTimelineClip);
  const timelineMarkers = useSelector(GetFilteredTimelineMarkers);
  const timelineTranscriptItems = useSelector(GetTimelineTranscriptItems);
  const isCreatingTimelineEvent = useSelector(GetCreatingOrEditingTimelineEvent);

  return (
    <Stack spacing={1} ref={ref}>
      {activeTimeline === TimelineType.Markers && timelineMarkers.length > 0 && (
        <MediaPlayerMarkers timecodes={timelineMarkers} />
      )}
      {activeTimeline === TimelineType.Clips && timelineClips.length > 0 && (
        <MediaPlayerClips clips={timelineClips} focusedClip={focusedClip} />
      )}
      {activeTimeline === TimelineType.Transcript && <TranscriptTimeline items={timelineTranscriptItems} />}
    </Stack>
  );
});
type TranscriptTimelineProps = {
  items: any[];
};

const TranscriptTimeline: React.FC<TranscriptTimelineProps> = ({ items }) => {
  const currentTime = useSelector(GetTimeInSec);
  const frameRate = useSelector(GetFrameRate);

  const currentCaption = items.find((x) => x.secIn <= currentTime && x.secOut >= currentTime);
  if (!currentCaption) return <></>;
  return (
    <Stack display={"flex"} position={"relative"} top={0} left={0} right={0} bottom={0} justifyContent={"center"}>
      <SingleCaption
        videoFps={frameRate ?? 25}
        top={0}
        position={"relative"}
        right={0}
        active={true}
        caption={currentCaption}
        currentTime={currentTime}
        index={1}
        isEditing={false}
        left={0}
        mode="stp"
      />
    </Stack>
  );
};
